export default __webpack_public_path__ + "static/media/stroller_pizza_1.de3a374f.png";